//import '@/assets/styles/all.scss';

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import plugins
import gsap from "./plugins/gsap";
import i18n from "./plugins/i18n";

function initYandexMetrika() {
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  window.ym(104764555, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
}

initYandexMetrika();

router.afterEach((to) => {
  if (typeof window.ym !== "undefined") {
    window.ym(104764555, "hit", to.fullPath);
  }
});

const app = createApp(App);

app.use(router).use(store).use(gsap).use(i18n);

app.mount("#app");
